import React from 'react';
import PromoCodeLabel from './PromoCodeLabel';
import { formatPrice } from '../../utils/utils';
import '../../styles/checkout-products.css';

export default function OrderTotals({ totalPrice, finalTotal, promo, showPromoCode = false, savingsLabel = 'Ви економите' }) {
  const promoDiscount = promo?.promoDiscountAmount ?? 0;
  const regularDiscount = Math.max(0, totalPrice - finalTotal - promoDiscount);
  const economy = totalPrice - finalTotal;
  const hasDiscountDetails = regularDiscount > 0 || Boolean(promo?.promoCode);
  return <div className='checkout-products-summary'>
    {hasDiscountDetails && <div className='checkout-summary-row checkout-summary-detail'>
      <span>Сума</span><strong>{formatPrice(totalPrice)} грн</strong>
    </div>}
    {regularDiscount > 0 && <div className='checkout-summary-row checkout-summary-detail'>
      <span>Знижка</span><strong>−{formatPrice(regularDiscount)} грн</strong>
    </div>}
    {promo?.promoCode && <div className='checkout-summary-row checkout-summary-detail order-totals-promo'>
      <PromoCodeLabel promo={promo} showCode={showPromoCode} />
      <strong>−{formatPrice(promoDiscount)} грн</strong>
    </div>}
    <div className={`checkout-summary-row checkout-summary-payable${hasDiscountDetails ? '' : ' checkout-summary-payable--only'}`}>
      <span>Сума до оплати:</span><strong className='checkout-summary-total'>{formatPrice(finalTotal)} грн</strong>
    </div>
    {regularDiscount > 0 && promoDiscount > 0 && <div className='checkout-summary-savings'>
      <span>{savingsLabel}</span>{' '}<strong>{formatPrice(economy)} грн</strong>
    </div>}
  </div>;
}
